export const SET_RECIPIENTS = 'SET_RECIPIENTS'
export const SET_CANNEDMESSAGES = 'SET_CANNEDMESSAGES'
export const SET_CANNEDMESSAGE = 'SET_CANNEDMESSAGE'
export const RESET_CANNEDMESSAGE = 'RESET_CANNEDMESSAGE'
export const SET_CANNEDMESSAGE_DATA = 'SET_CANNEDMESSAGE_DATA'

export const SET_MESSAGES = 'SET_MESSAGES'
export const SET_MESSAGE = 'SET_MESSAGE'
export const RESET_MESSAGE = 'RESET_MESSAGE'
export const SET_MESSAGE_DATA = 'SET_MESSAGE_DATA'
